module.exports = __webpack_public_path__ + "static/media/road-F.b881667e.svg";